import { apiInstance } from ".";

// data/newsData.js
export const staticNews = [
  {
    id: 1,
    title: "SpaceX Launches New Rocket",
    post: "SpaceX successfully launched a new rocket from Cape Canaveral today, marking another step in their space exploration efforts.",
    image: "https://images.unsplash.com/photo-1526779259212-939e64788e3c?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8ZnJlZSUyMGltYWdlc3xlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 2,
    title: "NASA Discovers New Planet",
    post: "NASA's telescope has found a new Earth-like planet in a distant galaxy. Scientists are excited about potential life-supporting conditions.",
    image: "https://images.unsplash.com/photo-1526779259212-939e64788e3c?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8ZnJlZSUyMGltYWdlc3xlbnwwfHwwfHx8MA%3D%3D",
  },
];


export const createNews = async(payload) => {
    const res = (await apiInstance.post("/news/",payload)).data
    return res;
}

export const getAllNews = async (numProducts, page) => {
    console.log("data",{numProducts,page})
    const res = ((await apiInstance.get(`/news/all?skip=${page}&limit=${numProducts}`)).data)
    return res;
}

export const getNews = async (id) => {
    const res = await apiInstance.get(`/news/${id}`)
    return res;
}

export const updateNews = async(sendedData , id)=>{
    const res = (await apiInstance.put(`/news/${id}`,sendedData)).data
    return res;
}

export const deleteNews = async(newsID)=>{
    const res = (await apiInstance.delete(`/news/${newsID}`)).data
    return res;
}